import CompanySettings from "../../client-data/company/company-settings";
import SessionEventProto from "../session-event-proto";

export default class SessionEvent_CompanySettingsReset extends SessionEventProto {


    constructor(sessionEvent:any) {
        super(sessionEvent)

        // this.header     = {
        //     expense     : sessionEvent.expense,
        //     isBulkUpdate: sessionEvent.isBulkUpdate,
        // }
    }


    process() {

        if (this.isDifferentCompany()) return false;

        // not sure old check
        if (gd.companyId !== this.data.id) return false

        const sessionOrganization = gd.session.companies.get(this.data.id)
        if (!sessionOrganization) return

        const newSettings = this.data.settings ? new CompanySettings(this.data.id, this.data.settings) : new CompanySettings(this.data.id, {})
        const shouldUpdateTree = sessionOrganization.settings.projectAccess.showParentsDespiteAccess !== newSettings.projectAccess.showParentsDespiteAccess

        sessionOrganization.settings = newSettings
        sessionOrganization.workWeek = newSettings.workSchedule.workWeek

        gd.workSchedule.updateCompanyWorkSchedule()

        // is required to update created fields (for now it is because of setting gd.company.settings.fields.projectHealthCanHaveNoValue)
        gd.fields.resetAll()

        if (shouldUpdateTree && gd.tree) { // there is a chance when there is no tree when new user creates new company (!) so we skip it in here!
            gd.tree.resetCompanyProjects(sessionOrganization.id)
        }

        gd.bus.triggerEvent('company-settings:reset')
    }
}
